import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaAngleDown, FaGenderless } from "react-icons/fa";

export default function SideBarItems({
  prefix,
  menu,
  toggleFlag,
  menuIndex,
  toggMenuFlagArr,
  menuLevel = null,
  firstParentIndex = null,
  secondParentIndex = null,
}) {
  // const [open, setOpen] = useState(false);

  const URI =
    prefix === "/"
      ? prefix + "" + menu.moduleName
      : prefix + "/" + menu.moduleName;

  const handleToggleArr = (
    menuIndex = null,
    firstParentIndex = null,
    secondParentIndex = null
  ) => {
    if (menuLevel === 1) {
      let tempArr = [...toggleFlag];

      tempArr?.map((toggleFlagFetch, ind) => {
        if (ind === menuIndex) {
          tempArr[ind].parent = !tempArr[ind].parent;
        } else {
          tempArr[ind].parent = false;
        }
      });
      toggMenuFlagArr(tempArr);
    } else if (menuLevel === 2) {
      let tempArr = [...toggleFlag];
      tempArr?.map((toggleFlagFetch, ind) => {
        if (ind === firstParentIndex) {
          toggleFlagFetch?.child?.map((toggleFlagFetch2, index) => {
            if (index === menuIndex) {
              toggleFlagFetch2.parent = !toggleFlagFetch2.parent;
            } else {
              toggleFlagFetch2.parent = false;
            }
          });
        }
      });
      toggMenuFlagArr(tempArr);
    } else if (menuLevel == 3) {
     
      let tempArr = [...toggleFlag];
      tempArr?.map((toggleFlagFetch, ind) => {
        if (ind === secondParentIndex) {
          toggleFlagFetch?.child?.map((toggleFlagFetch2, index) => {
            if (index === firstParentIndex) {
              toggleFlagFetch2?.child?.map((toggleFlagFetch3, indx) => {
                if (indx === menuIndex) {
                  toggleFlagFetch3.parent = !toggleFlagFetch3.parent;
                } else {
                  toggleFlagFetch3.parent = false;
                }
              });
            }
          });
        }
      });
      toggMenuFlagArr(tempArr);
    } //update if menuLevel Increases
  };

  let subMenus;
  if (menu?.firstData) {
    subMenus = menu.firstData;
  } else if (menu?.secondData) {
    subMenus = menu?.secondData;
  } else if (menu?.thirdData) {
    subMenus = menu.thirdData;
  }

  if (subMenus !== undefined && subMenus.length > 0) {
    return (
      // <div className={open ? "sidebar-item open" : "sidebar-item"}>
      //    <div className="sidebar-title" onClick={() => setOpen(!open)}>
      <div
        className={
          menuLevel === 1 ? (
            toggleFlag?.[menuIndex]?.parent ? (
              "sidebar-item open"
            ) : (
              "sidebar-item"
            )
          ) : menuLevel === 2 ? (
            toggleFlag?.[firstParentIndex]?.child?.[menuIndex]?.parent ? (
              "sidebar-item open"
            ) : (
              "sidebar-item"
            )
          ) : menuLevel === 3 ? (
            toggleFlag?.[secondParentIndex]?.child?.[firstParentIndex]?.child?.[
              menuIndex
            ]?.parent ? (
              "sidebar-item open"
            ) : (
              "sidebar-item"
            )
          ) : (
            // : menuLevel === 4 ? (    try thi if level increases
            //   toggleFlag?.[secondParentIndex]?.child?.[firstParentIndex]?.child?.[menuIndex]?.parent  ? (
            //     "sidebar-item open"
            //   ) : (
            //     "sidebar-item"
            //   )
            // )
            <></>
          )
        }
      >
        <div
          className="sidebar-title"
          onClick={() =>
            handleToggleArr(menuIndex, firstParentIndex, secondParentIndex)
          }
        >
          <p className="flex items-center">
            <FaGenderless /> &nbsp; {menu.moduleDisplayName}
          </p>
          <FaAngleDown className="bi-chevron-down toggle-btn" />
        </div>
        <div className="sidebar-content">
          {subMenus.map((child, index) => (
            // <SideBarItems key={index} prefix={URI} menu={child} />
           
            <SideBarItems
              key={index}
              prefix={URI}
              menu={child}
              menuIndex={index}
              firstParentIndex={menuIndex}
              secondParentIndex={firstParentIndex}
              toggleFlag={toggleFlag}
              toggMenuFlagArr={toggMenuFlagArr}
              menuLevel={menuLevel + 1}
            />
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <Link to={URI} className="sidebar-item plain">
        <p className="flex items-center">
          <FaGenderless /> &nbsp;
          {menu.moduleDisplayName}
        </p>
      </Link>
    );
  }
}
